export default __webpack_public_path__ + "static/media/team-players.97801680.svg";